/**
 * Component used for grouping card content when breaking via:
 *  - screen size
 *  - card layout
 */

import { Component } from '@angular/core';

@Component({
  selector: 'va-card-break-group',
  templateUrl: './va-card-break-group.component.html',
  styleUrls: ['./va-card-break-group.component.scss'],
})
export class VaCardBreakGroupComponent {}
